import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function VerifyCertificate() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState(false);
  const [hidden, setHidden] = useState(false);
  useEffect(() => { api.get(`/certificates/${id}/verify`).then((r) => setC(r.data)).catch(() => setErr(true)); }, [id]);
  useEffect(() => {
    const off = () => setHidden(true);
    const on = () => setHidden(false);
    window.addEventListener("blur", off); window.addEventListener("focus", on);
    return () => { window.removeEventListener("blur", off); window.removeEventListener("focus", on); };
  }, []);
  return (
    <div className="max-w-xl mx-auto px-6 py-20 text-center space-y-5" data-testid="verify-certificate-page">
      <p className="font-mono text-xs tracking-[0.25em] text-[#8C4F27]">CERTIFICATE VERIFICATION</p>
      {err && <p className="font-serif text-3xl text-[#9E2A2B]" data-testid="certificate-invalid">Certificate not found</p>}
      {c && (
        <div className={`bg-white border border-[#E6DFD5] p-8 space-y-3 select-none print:hidden transition-[filter] ${hidden ? "blur-xl" : ""}`} data-testid="certificate-valid">
          <BadgeCheck className="mx-auto text-[#2E6B40]" size={40} />
          <p className="text-sm text-[#2E6B40] tracking-wider">AUTHENTIC CRAFTENDEMIC CERTIFICATE</p>
          <h1 className="font-serif text-3xl">{c.user_name}</h1>
          <p>{c.title}</p>
          <p className="text-sm text-[#6E6259]">Issued on {new Date(c.issued_at).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })} · {c.certificate_id}</p>
        </div>
      )}
    </div>
  );
}
